
//import './libs/detectizr/modernizr-custom';
//import './libs/detectizr/detectizr.min';
//import '@iconfu/svg-inject/dist/svg-inject';

//import $ from 'jquery';

import Main from './src/main';

var CFA_APP;

$(document).ready( ()=>{


	
	const loc = document.location, 
		is_ajax = ((loc.hostname.indexOf( 'cfa.whirl-i-gig' ) === -1) && (loc.hostname.indexOf( 'collections.chicagofilmarchives' ) === -1));


	//console.log( 'CFA = ' + (!is_ajax) );

	const app = new Main({
		is_ajax 					: is_ajax,
		is_CA 						: !is_ajax,

		debug						: false,
		slide_transition			: false,
		time_fade_in 				: 0.1,
		time_fade_out 				: 0.1,
		
		ease_fade_in 				: 'power1.out',
		ease_fade_out       		: 'sine.out',
		include_footer_transition	: false,

		scrollSmooth 				: false,

		project_name				: 'Chicago Film Archives',
		//GA_MEASUREMENT_ID 			: 'G-7P20413XZD',
					
		redirects			: [
			// ['/practice/', '/practice/about/']
		]

	});

	app.init();

	window.CFA_APP = app;
	
});

